import { render, staticRenderFns } from "./DamageRegulationStatisticsCard.vue?vue&type=template&id=19fb1108&scoped=true"
import script from "./DamageRegulationStatisticsCard.vue?vue&type=script&lang=ts"
export * from "./DamageRegulationStatisticsCard.vue?vue&type=script&lang=ts"
import style0 from "./DamageRegulationStatisticsCard.vue?vue&type=style&index=0&id=19fb1108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb1108",
  null
  
)

export default component.exports